import EducationalProgramsCatalogPage from "./EducationalProgramsCatalogPage";

export default EducationalProgramsCatalogPage;